const initBanner = () => {
  const banner = document.querySelector(".banner");

  if (!banner) return;

  const trackScroll = () => {
    if (window.scrollY > 0) {
      banner.classList.add("active");
    } else {
      banner.classList.remove("active");
    } 
  };

  window.addEventListener("scroll", trackScroll);

  /* Замена ссылки на кнопке баннера */
  const catalog = document.getElementById('products');

  if (!catalog) {
    banner.querySelector('a').href = '/#products';
  }
};

export default initBanner;
